import { observer } from 'mobx-react';
import ModalStore from '../../../../../Modal/Store';
import InvitationStore from '../../Store/InvitationStore';
import DeactivateConfirmation from './DeactivateConfirmation';
import DeactivateSuccess from './DeactivateSuccess';
import ReactivateSuccess from './ReactivateSuccess';
import Loader from '../../../../../Loader';
import FlashMessage from '../../../../../FlashMessage';
import { errorAlert } from '../../../../../../Notifications/Types';

interface Props {
  store: InvitationStore;
  modalStore: ModalStore;
}

function Form({ store, modalStore }: Props) {
  const { state } = store;
  switch (state.kind) {
    case 'confirming-deactivate':
      return <DeactivateConfirmation state={state} store={store} />;
    case 'deactivate-succeeded':
      return <DeactivateSuccess state={state} modalStore={modalStore} />;
    case 'reactivate-succeeded':
      return <ReactivateSuccess state={state} modalStore={modalStore} />;
    case 'waiting':
    case 'deactivating':
    case 'reactivating':
      return <Loader className="h-full py-40" />;
    case 'error':
      return <FlashMessage alert={errorAlert(state)} />;
  }
}

export default observer(Form);
